const initialState = () => ({
  agents: [], // Lista de agentes
  simpleAgents: [], // agentes con datos básicos: names, surnames, userId
})

export default initialState
